import { MarketButton } from '@market/react';
import { ReactComponent as ExclamationCircle } from '@market/icons/assets/svg/exclamation-circle.svg';

type ConnectionErrorProps = {
  onClickTryAgain: () => void;
};

const ConnectionErrorScreen = ({ onClickTryAgain }: ConnectionErrorProps) => {
  return (
    <div
      data-testid="connection-error-screen"
      className="addons-full-width-and-height addons-center-items addons-modal-flex-direction addons-direct-child-spacing"
    >
      <div>
        <ExclamationCircle
          className="addons-exclamation-circle-icon"
          width="80"
          height="80"
        />
      </div>
      <div className="addons-text-align-center addons-connection-error-element-width">
        <strong>Connection error</strong>
        <p style={{ margin: '10px 0 0 0' }}>
          Please check your connection and try again. If you continue having
          issues, turn off Square Loyalty in Settings to continue.
        </p>
      </div>
      <MarketButton
        className="addons-connection-error-element-width"
        data-testid="connection-error-try-again-button"
        onClick={onClickTryAgain}
        rank="primary"
      >
        Try again
      </MarketButton>
    </div>
  );
};

export default ConnectionErrorScreen;
